/**
 * Generated runtime TestId mirror for frontend/src/contexts/auth-loop-page.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const AuthLoopPageTestIds = {
  authLoopLogoutFully: "auth-loop-logout-fully",
  authLoopTitle: "auth-loop-title",
  authLoopTryAgain: "auth-loop-try-again"
} as const;
